import createReactComponent from '../createReactComponent';
export default createReactComponent('chevrons-up', 'ChevronsUp', [["path",{"d":"m18 12-6-6-6 6m12 6-6-6-6 6","key":"svg-0"}]]);